export default __webpack_public_path__ + "static/media/16@3x.9597ba93.png";